import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialSubsection } from '../../report/editorial';

export const FloodNaturalHazardsSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const data = report.floodNaturalHazards;
  const hasData = !!data && !!(
    data.femaFloodAnalysis || data.coastalZoneManagement || data.seaLevelRise ||
    data.seismicImpact || data.climateResiliency
  );
  return (
    <SectionShell label={label} hasData={hasData}>
      {data?.femaFloodAnalysis && <EditorialSubsection theme={theme} label="FEMA Flood Analysis">{data.femaFloodAnalysis}</EditorialSubsection>}
      {data?.coastalZoneManagement && <EditorialSubsection theme={theme} label="Coastal Zone Management (CZMA)">{data.coastalZoneManagement}</EditorialSubsection>}
      {data?.seaLevelRise && <EditorialSubsection theme={theme} label="Sea Level Rise">{data.seaLevelRise}</EditorialSubsection>}
      {data?.seismicImpact && <EditorialSubsection theme={theme} label="Seismic Impact">{data.seismicImpact}</EditorialSubsection>}
      {data?.climateResiliency && <EditorialSubsection theme={theme} label="Climate Resiliency">{data.climateResiliency}</EditorialSubsection>}
    </SectionShell>
  );
};
